/** @format */

import axios from "axios";

const axiosInstance = axios.create({});

axiosInstance.interceptors.request.use((config) => {
  const searchParams = new URLSearchParams(config?.url?.split("?")[1]);
  const tokenFromQueryParam = searchParams?.get("developer_token");

  config.params = {
    ...config.params,
    // app_id: "1",
    // company_id: companyIdFromQueryParam
    //   ? companyIdFromQueryParam
    //   : config.params?.company_id || localStorage.getItem("company_id"),
  };

  if (tokenFromQueryParam) {
    // Check if tokenFromQueryParam is null before setting Authorization header
    tokenFromQueryParam === null ? '' : (config.headers["Authorization"] = "Bearer " + tokenFromQueryParam);
  } else {
    const storedToken = localStorage.getItem("developer_token");
    // Check if storedToken is null before setting Authorization header
    storedToken === null ? null : (config.headers["Authorization"] = "Bearer " + storedToken);
  }

  if (config?.data?.Content) {
    config.headers["Content-Type"] = config?.data?.Content;
  } else {
    config.headers["Content-Type"] = "application/json";
  }
  //  config.headers["Access-Control-Allow-Origin"] = "*";
  if (config.data instanceof FormData) {
    config.headers["Content-Type"] = "multipart/form-data";
  }


  return config;
});

axiosInstance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response.data;
  },
  function (error) {
    handleError(error);
    // Any status codes that fall outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error.response.data);
  }
);

const handleError = (error) => {
  if (error.response.status === 401) {
    localStorage.clear();
    window.location.href = "/";
  }
};

export default axiosInstance;
